let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kjc3e")).then(() => parcelRequire('iNBri'));